import React from 'react';
import PaginationTable from '../PaginationTable';
import {
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Button,
    ButtonGroup,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from 'reactstrap';
import Dropzone from 'react-dropzone';
import {Link} from 'react-router';

import {apiUrl} from '../../../config';

const defaultMsg = "Selecciona un archivo XLSX";
   
const uploadKinds = {
    clients  : 'Cartera',
    users    : 'Plantilla',
    coaching : 'Coaching',
}     

const uploadTemplates = {
    clients : `${apiUrl()}/uploads/templates/clients`,
    users   : `${apiUrl()}/uploads/templates/users`,
    coaching   : `${apiUrl()}/uploads/templates/coaching`,
}

export default class UploadsIndex extends React.Component {

    constructor(props) {
        super(props);
        this.hideModal = this.hideModal.bind(this);
        this.showModal = this.showModal.bind(this);
        this.upload = this.upload.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
        this.uploadMessage = this.uploadMessage.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.state = {showLayoutDropdown : false, showModal : false, dropMessage : defaultMsg, kind : 'clients'};
    }

    componentWillReceiveProps(props) {
        const uploadState = props.uploadState;
        if(uploadState.uploadDone) {
            this.props.clearUploadData();
            this.setState({showModal : false});
            this.props.fetchUploads(1);
        }
    }

    componentWillMount() {
        this.props.fetchUploads();
    }
    
    showModal() {
        this.setState({
            showModal : true,
            errorMessage : null,
        });
    }

    hideModal() {
        if(this.errorTimeout) {
            clearTimeout(this.errorTimeout);
            this.errorTimeout = undefined;
        }
        this.setState({
            showModal : false,
            errorMessage : null,
        });
        if(this.props.uploadState.uploading) {
            const xhr = this.props.uploadState.xhr;
            if(xhr) {
                xhr.abort();
            }
            
        }else {
            this.props.clearUploadData();    
        }
        
    }


    onDrop(accepted, rejected) {
        if(accepted.length === 1 && rejected.length === 0) {
            const file = accepted[0];
            this.props.uploadFileSelected(file);
        }else if(accepted.length > 0) {
            this.showError("Por favor, selecciona únicamente un archivo");
        }
        let message = defaultMsg;
        this.setState({
            dropMessage : message
        });
        
    }

    onDragEnter(evt) {
        let message = this.uploadMessage();
        this.setState({
            dropMessage : message
        });
    }

    onDragLeave(evt) {
        let message = defaultMsg;
        this.setState({
            dropMessage : message
        });
    }

    upload() {
        this.props.uploadFile(this.props.uploadState.file, {
            kind : this.state.kind
        });
    }

    uploadMessage() {
        const dropzone = this.refs.dropzone;
        let message = defaultMsg;
            
        try {
            const dropState = dropzone.state;
            if(dropState.isDragActive) {
                message = "Suelta tu archivo aquí";
            }else if(dropState.isDragReject) {
                message = "Por favor, solo selecciona archivos XLSX";
            }
        }catch(e) {}

        return message;
    }

    showError(errorMessage) {
        if(this.errorTimeout) {
            clearTimeout(this.errorTimeout);
            this.errorTimeout = undefined;
        }
        this.setState({errorMessage})
        this.errorTimeout = setTimeout(() => this.setState({errorMessage : null}), 5000);
    }

    pageChange(page) {
        this.props.fetchUploads(page);
    }

    render() {
        const state = this.props.uploadState;
        const paginationData = state.data;
        return (
            <div>
                <div className="container">
                    <div className="text-right mb-2">
                        <ButtonDropdown isOpen={this.state.showLayoutDropdown} toggle={
                            () => this.setState(prevState => {
                                return {
                                    showLayoutDropdown : ! prevState.showLayoutDropdown
                                }
                            })
                        }>
                            <DropdownToggle caret>
                                <i className="fa fa-fw fa-download"></i> Layout
                            </DropdownToggle>
                            <DropdownMenu>
                                {
                                    Object.keys(uploadTemplates).map(key => (
                                        <DropdownItem key={key} tag={Link} target="_blank" to={uploadTemplates[key]}>
                                            {uploadKinds[key]}
                                        </DropdownItem>
                                    ))
                                }
                            </DropdownMenu>
                        </ButtonDropdown>
                        <button className="btn btn-secondary ml-1" onClick={this.showModal}> <i className="fa fa-fw fa-plus"></i> Añadir carga</button>
                    </div>
                    <PaginationTable {...paginationData} headerComponent={uploadsHeader} rowComponent={uploadsRow} pageChange={this.pageChange}/>
                </div>

                <Modal isOpen={this.state.showModal} toggle={this.hideModal}>
                    <ModalHeader>
                        Añadir nueva carga
                    </ModalHeader>
                    <ModalBody>
                        {
                            (state.uploadDone) ?
                                (
                                    <div>
                                        Carga completada
                                    </div>
                                )
                            :
                                (
                                    (state.uploading) ?
                                        (
                                            <div className="progress w-100">
                                                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow={state.progress} aria-valuemin={0} aria-valuemax={100} style={{width: state.progress + '%'}}></div>
                                            </div>
                                        )
                                    :
                                        (
                                            <div>
                                                <Dropzone
                                                    ref="dropzone"
                                                    className="dropzone"
                                                    activeClassName="active"
                                                    onDragEnter={this.onDragEnter}
                                                    onDragLeave={this.onDragLeave}
                                                    onDrop={this.onDrop}
                                                    rejectClassName="reject"
                                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                    multiple={false} >
                                                    {
                                                        state.file ? 
                                                            <span>{state.file.name}</span>
                                                        :
                                                            <span>{this.state.dropMessage}</span>
                                                    }
                                                </Dropzone>

                                                <div className="text-center mt-2">
                                                    <ButtonGroup>
                                                        {
                                                            Object.keys(uploadKinds).map(key => (
                                                                <Button outline key={key} color="primary" onClick={() => this.setState({kind : key})} active={this.state.kind === key}>{uploadKinds[key]}</Button>
                                                            ))
                                                        }
                                                    </ButtonGroup>
                                                </div>
                                                
                                            </div>
                                            

                                        )
                                )
                        }
                        
                        {
                            this.state.errorMessage ?
                                (
                                    <div className="text-danger">
                                        {this.state.errorMessage}
                                    </div>
                                )
                            :
                                ''
                        }
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-secondary" onClick={this.hideModal}>Cancelar</button>
                        <button className="btn btn-primary" disabled={state.file == null} onClick={this.upload}> <i className="fa fa-fw fa-upload"></i> Subir</button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

function uploadsHeader(props) {
    return (
        <tr>
            <th></th>
            <th>
                ID de carga
            </th>
            <th>
                Archivo
            </th>
            <th>
                Registros leídos
            </th>
            <th></th>
        </tr>
    );
}

function uploadsRow(props) {
    const item = props.item;
    let icon;
    switch(item.status) {
        case 'pending' :
            icon = (<i className="fa fa-circle-o fa-fw"></i>);
            break;
        case 'processing' :
            icon = (<i className="fa fa-spinner fa-spin fa-fw"></i>);
            break;
        case 'done' :
            icon = (<i className="fa fa-check fa-fw"></i>);
            break;
        case 'rejected' :
            icon = (<i className="fa fa-times fa-fw"></i>);
            break;
        default :
            icon = null;
            break;
    }
    return (
        <tr>
            <td>
                {
                    icon
                }
            </td>
            <td>
                {item.id}
            </td>
            <td>
                {item.file_name}
            </td>
            <td>
                {item.read}
            </td>
            <td>
                <Link className="btn btn-sm btn-primary" to={`/uploads/${item.id}`}>
                    Detalle
                </Link>
            </td>
        </tr>
    );
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/uploads/UploadsIndex.jsx
 **/